module.exports = __webpack_public_path__ + "img/introduce-icon2.970be2f2.png";